/* eslint-disable */
import React, { Component } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Tooltip,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  withStyles,
  Icon,
} from '@material-ui/core';
import { useStyles } from '../../style';
import iconoVentas from '../../../../../assets/icons/ventas.png';
import { da, tr } from "date-fns/locale";
import { tooltip } from "aws-amplify";

export default function PastelBalance({ data, icon }) {

  console.log("chartDataPasivos", data)
  const classes = useStyles();

  const series = data.series;
  const labels = data.labels;
  const title = data.title;

  const chartData = {
    series: series,
    options: {
      chart: {
        // sparkline: {
        //   enabled: true
        // },
        width: '100%',
        height: '325px',
        type: 'pie',
        background: 'transparent',
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      plotOptions : {
        pie: {
          customScale: 0.8,
          offsetY: -15,
          expandOnClick: false,
          dataLabels: {
            offset: 43,
            // minAngleToShowLabel: 10
          },
        },
      },
      tooltip: {
        y: { formatter: (val) => `$${new Intl.NumberFormat('en-US', {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(val)}`}
      },
      labels: labels,
      stroke: {
        width: 20,
        color: ['transparent'],
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            // width: '50px'
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      colors: ['#083673', '#022044', '#5997bb'],
      dataLabels: {
        enabled: true,
        // textAnchor: 'start',
        style: {
          fontSize: '20px',
          colors: ['#083673', '#022044', '#5997bb'],
        },
        dropShadow: {
          enabled: false,
        },
      },
      legend: {
        show: true,
        width: '110px',
        // height: 45,
        position: 'bottom',
        fontSize: '12px',
        horizontalAlign: 'center',
        // offsetY: 10
      }
    },
  }
  


  return (

    <Grid component={Card} pt={3} marginX={1}>
      <Grid className={classes.chartLineBarsBox} item pb={1} px={2}>
        <div>
          <img src={icon} alt="costos x ventas" width="35px" height="35px" />
        </div>
        <Typography className={classes.chartBarDonutTitle} paddingLeft={2}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} minWidth={425} style={{height:'300px'}}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="pie"
          width="100%"
        />
      </Grid>

    </Grid>


  );
}
